import AccountInfo from './AccountInfo';
import ChargeIndividual from './ChargeIndividual';
import Expense from './Expense';
import VendorInvoice from './VendorInvoice';

export default class VoucherMaintenanceForm {
    voucherId: number;           // Unique identifier for the voucher
    vendorId: number;            // Reference to the vendor or supplier
    vendorName: string;          // Name of the vendor
    invoiceNumber: number;       // Invoice number from the vendor
    invoiceDate: Date;           // Date the invoice was issued
    invoiceAmount?: number;
    dueDate: Date;               // Date when the payment is due
    closeDate: Date;             // Date when the voucher was created
    approvalDate?: Date;         // Date when the voucher was approved
    description?: string;        // Optional description of the voucher or transaction
    paymentStatus: 'Pending' | 'Paid' | 'Cancelled';  // Status of the payment
    paymentMethod?: string;      // Payment method (e.g., Wire Transfer, Check)
    paymentNumber?: number;
    reoccurNumber?: number;
    approvedBy?: string;         // Name or ID of the person who approved the payment
    taxAmount?: number;          // Tax amount related to the voucher, if applicable
    taxRate?: number;            // Tax rate applied on the transaction
    accountCode?: string;        // GL account code where the expense is recorded
    voucherAccountId: number;    // This is the id to match to AP_VOUCHER_ACCOUNTS

    // Voucher
    vendorNumber: number;
    voucherNumber: string;
    vendorInvoice: string;
    voucherAmount: number;
    isVoucherVoid: boolean;
    dateVoucherVoided: Date;
    reoccuranceNumber: number;
    checkVoidDate: Date;
    checkVoidState: boolean;

    // Check
    checkNumber?: number;
    checkDate?: Date;
    isCheckVoid?: boolean;
    dateCheckVoided?: Date;

    voucherExpenses?: Expense[];
    voucherAccounts?: Expense[];
    voucherInvoices?: VendorInvoice[];
    chargeIndividual: ChargeIndividual[];
    accountInfo: AccountInfo;
}



// WEBPACK FOOTER //
// ./src/models/AP/VoucherMaintenanceForm.ts